import React from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import useUser from 'shared/hooks/use-user'
import { isYesterday } from 'shared/utils/date-time-format'
import { ArrowDownSmoothIcon } from '@systemeio/ui/icons'

export interface ChartBoxProps {
  title: string
  total: string
  diffPercents: number
  countDays: number
  dateSince: string | null
  chart: JSX.Element
}

const ChartBox = ({ title, total, diffPercents, countDays, dateSince, chart }: ChartBoxProps) => {
  const { t } = useLocoTranslation()
  const { user } = useUser()
  return (
    <div
      className={
        'shadow-old-design font-averta bg-background-secondary flex h-[340px] w-full flex-col justify-between rounded-lg pb-1 pt-6 md:w-[calc(50%-10px)] lg:w-full xl:w-[calc(50%-10px)]'
      }
    >
      <div className={'flex justify-between px-6'}>
        <div className={'flex flex-col gap-2.5'}>
          <span className={'text-text-tertiary font-semibold leading-none'}>{title}</span>
          <span className={'text-brand-primary text-4xl leading-none'}>{total}</span>
        </div>
        <div
          className={`${
            diffPercents >= 0
              ? 'bg-old-green/[0.1] text-old-green'
              : 'bg-old-red/[0.1] text-old-red'
          } flex h-fit flex-col rounded-md px-3.5 pb-2 pt-3`}
        >
          <div className={'flex items-center gap-2'}>
            <ArrowDownSmoothIcon
              className={`${
                diffPercents >= 0 ? 'fill-old-green' : 'fill-old-red rotate-180'
              } scale-90`}
            />
            <span className={`text-[20px] font-bold leading-5`}>{diffPercents}%</span>
          </div>
          <span className={'text-xs'}>
            {isYesterday(dateSince, user?.timezone) && countDays === 1
              ? t('dashboard.main.one_day_ago').toLowerCase()
              : t('dashboard.main.last_days', { count: countDays }).toLowerCase()}
          </span>
        </div>
      </div>
      <div className={'ml-[0px] mr-[11px]'}>{chart}</div>
    </div>
  )
}
export default ChartBox
